import React from 'react';
import LoginImage from "../image/LoginImage.svg";
import { Link } from 'react-router-dom';
import "./Login.css";

const Login = () => {
  return (
    <div className='LoginPage'>
      <div className='row LoginRow'>
      <div className='col-md-4 col-xs-4 LoginImage-Section'>
        <img src={LoginImage} className="LoginImage-Settings"/>
      </div>
      <div className='col-md-8 col-xs-8 LoginDetails-Section'>
      <div className="Form">
                     <div className="Heading">
                         <span className="Login">Login to your account</span><br/>
                         <span className="Login_Text">Already have an account? <strong><Link to="" className="Login_Link">Log in</Link> </strong></span>
                       </div>                                         
                      <div className="container">
                         <form className='Form-details-block'>
                              <div className="form-group Form-Group">
                                  <label className='LabelDesign'>User name</label>
                                   <input type="text" placeholder="Enter your Email here" className="form-control InputBox"/>
                              </div>
                                <div className="form-group Form-Group">
                                    <label className='LabelDesign'>Password</label>
                                    <input type="password" placeholder="Enter your Password here" className="form-control InputBox"/>
                              </div>
                                 <strong className="Forgot_Password" ><Link to="" style={{"textDecoration":"none"}} className="Login_Link">Forgot Password?</Link></strong><br/>
                               <div className="button">
                                  <button className="btn LoginPage-LoginButton">Log in</button>
                               </div>  
                         </form>
                     </div>
                  </div>
      </div>
      </div>
    </div>
  )
}

export default Login;